export const getOidcUserManagerConfig = () => {
    const hostname = window.location.hostname;
    const isReviewMergeRequest = /^reviewmr\d+\./i.test(hostname);

    return {
      client_id: 'cwhome_code',
      redirect_uri: `${window.location.protocol}//${hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }/signin-oidc`,
      response_type: 'code',
      scope: 'openid profile email api.home api.users approles roles',
      authority: hostname.includes('home.connectwise.com')
        ? 'https://auth.connectwise.com'
        : hostname.includes('int.home.connectwisedev.com') || isReviewMergeRequest
        ? 'https://int.sts.connectwisedev.com'
        : 'https://sts.connectwisedev.com',
      silent_redirect_uri: `${window.location.protocol}//${hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }/silent_refresh.html`,
      automaticSilentRenew: true,
      silentRequestTimeout: 1000 * 20,
      post_logout_redirect_uri: `${window.location.protocol}//${
        window.location.hostname
      }${window.location.port ? `:${window.location.port}` : ''}`,
      mergeClaimsStrategy: {
        array: 'replace'
      },
      response_mode: null,
      loadUserInfo: true,
      monitorSession: true,
      validateSubOnSilentRenew: true,
      includeIdTokenInSilentRenew: true
    };
  };